export default {
  default: {
    child: {
      flex: '0 0 auto',
    },
  },

  grow: {
    child: {
      flex: '1 1 auto',
      overflow: 'auto',
    },
  },
} as const
